/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDim2DiagMinRightIcon16Light } from './ArrowDim2DiagMinRightIcon16Light';
import { ArrowDim2DiagMinRightIcon16Regular } from './ArrowDim2DiagMinRightIcon16Regular';
import { ArrowDim2DiagMinRightIcon16Solid } from './ArrowDim2DiagMinRightIcon16Solid';
import { ArrowDim2DiagMinRightIcon20Light } from './ArrowDim2DiagMinRightIcon20Light';
import { ArrowDim2DiagMinRightIcon20Regular } from './ArrowDim2DiagMinRightIcon20Regular';
import { ArrowDim2DiagMinRightIcon20Solid } from './ArrowDim2DiagMinRightIcon20Solid';
import { ArrowDim2DiagMinRightIcon24Regular } from './ArrowDim2DiagMinRightIcon24Regular';
import { ArrowDim2DiagMinRightIcon24Solid } from './ArrowDim2DiagMinRightIcon24Solid';
import { ArrowDim2DiagMinRightIcon32Regular } from './ArrowDim2DiagMinRightIcon32Regular';
import { ArrowDim2DiagMinRightIcon64Regular } from './ArrowDim2DiagMinRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowDim2DiagMinRightIcon16Light,
        regular: ArrowDim2DiagMinRightIcon16Regular,
        solid: ArrowDim2DiagMinRightIcon16Solid,
    },
    20: {
        light: ArrowDim2DiagMinRightIcon20Light,
        regular: ArrowDim2DiagMinRightIcon20Regular,
        solid: ArrowDim2DiagMinRightIcon20Solid,
    },
    24: {
        regular: ArrowDim2DiagMinRightIcon24Regular,
        solid: ArrowDim2DiagMinRightIcon24Solid,
    },
    32: {
        regular: ArrowDim2DiagMinRightIcon32Regular,
    },
    64: {
        regular: ArrowDim2DiagMinRightIcon64Regular,
    },
};
export var ArrowDim2DiagMinRightIcon = forwardRef('ArrowDim2DiagMinRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
